import service from '@/services/SICUDgpd_est_crd3';

export default {
  namespaced: true,

  actions: {
    async update({ dispatch, rootGetters }, event) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_est_crd: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_est_crd: [
              {
                doc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || event.documentNumber,
                crd_nom1: event.firstName,
                crd_nom2: event.secondName,
                crd_apl1: event.lastName,
                crd_apl2: event.secondLastName,
                ciu_cod: event.birthCity,
                ter_ncto: event.birthDate,
                crd_exp: event.dateExp,
                ciu_cod_exp: event.expeditionCity,
              },
            ],
          },
        };

        let notification;

        service.put(payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_est_crd;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data.eegpd_est_crd[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },

  getters: {
    state(state) {
      return {
        ...state,
      };
    },
  },
};
